import { BaseToastProps, useBaseToast } from '../use-base-toast';

export function useOnErrorToast({ title, description }: BaseToastProps) {
  return useBaseToast({
    title,
    description,
    status: 'error',
  });
}
